/**
 * Check if an identifier looks like a username (matches username validation pattern).
 * Usernames must match: /^@?[a-zA-Z0-9]{3,30}$/
 * User IDs don't match this pattern (they may be UUIDs, prefixed strings, etc.)
 */
export function isUsername(identifier: string): boolean {
  const normalized = identifier.replace(/^@+/, '');
  return /^[a-zA-Z0-9]{3,30}$/.test(normalized);
}
